import { BASE_URL } from "config";
import * as base from "./_base";

export const endpoints = {
  list: `${BASE_URL}/api/v1/seo/template/page/`,
  detail: (id) => `${BASE_URL}/api/v1/seo/template/page/${id}/`,
};

export const seoTemplatePageListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const seoTemplatePageDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const seoTemplatePageUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const seoTemplatePageDelete = (token, data) => base.Delete(endpoints.detail, token, data);
